import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";

import { CustomToastContent } from "../../../../examples/CustomToastContent/index";

// @mui material components
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

import { toast } from "react-toastify";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import DownloadButton from "components/standardized-components/DownloadButton";

// React-Select component
import Select from "react-select";

import "react-toastify/dist/ReactToastify.css";

// import { CSVLink } from "react-csv";
import { CSVLink } from "react-csv";

// Custom standard components
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";

import CreateTestRecordModal from "../CreateTestRecordModal/index";

// Functions from store (Update path as per your project)
import {
  getHardnessTest,
  createHardnessTest,
  editHardnessTest,
  deleteHardnessTest,
  getProductsListForDpp,
  getSubModulesByRoleId,
  uploadCsvForHardnessTest,
} from "../../../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 800 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
};

// const styleForEdit = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: 350, lg: 750 },
//   height: "fit-content",
//   maxHeight: "90%",
//   boxShadow: 24,
//   p: 1,
//   pt: 3,
//   overflow: "scroll",
// };

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 500, lg: 900 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
  // overflowX: "hidden",
};



const HardnessTest = ({
  getHardnessTestReducer,
  getHardnessTest,
  createHardnessTest,
  editHardnessTest,
  deleteHardnessTest,
  dppIdSelectedForGlobalFilter,
  dropdownUI,
  getProductsListForDpp,
  getProductsListForDppReducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  uploadCsvForHardnessTest,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data?.userId;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "a5fde116-00b7-4ce0-939b-2482c5d161e1",
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "896c7b19-7fe5-4306-9f06-2735e57a7b84",
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "9acd851e-2dc1-4bd1-a480-e7621d85ace8",
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "483ae968-cc38-4d30-ba63-887e9d32ba71",
    )
    : null;

  const [loading, setLoading] = useState(true);

  // For DPP Dropdown Options
  const [dppOptions, setDPPOptions] = useState([]);
  const [dppIdSelected, setdppIdSelected] = useState("");
  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");

  const [openCreateModal, setOpenCreateModal] = useState(false);

  useEffect(() => {
    getProductsListForDpp(jwtToken);
  }, [jwtToken]);
  useEffect(() => {
    let tempDppOptions = [];
    let dataList = getProductsListForDppReducer?.productsListForDpp?.data
      ? getProductsListForDppReducer.productsListForDpp.data
      : [];

    dataList.forEach((item) => {
      tempDppOptions.push({
        label: item.dppCode,
        value: item.dppId,
      });
    });

    setDPPOptions(tempDppOptions);
  }, [getProductsListForDppReducer]);

  // Fetch Initial Data
  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      getHardnessTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      getHardnessTest(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);


  const testTypeOptions = [
    { label: "Tensile Test", value: "tensile" },
    { label: "Hardness Test", value: "hardness" },
    { label: "Notch Impact Test", value: "notchImpact" },
  ];

  const passFailOptions = [
    { label: "Pass", value: 1 },
    { label: "Fail", value: 0 },
  ];

  const overchargeUnitOptions = [
    { label: "V/cell", value: "V/cell" },
  ];

  // DataTable State
  const [state, setState] = useState({
    columns: [
      { Header: "Test ID", accessor: "hardnessTestId" },
      { Header: "DPP Code", accessor: "dppCode" },
      { Header: "Notch Impact Strength(Mean)(kJ/m²)", accessor: "notchimpactStrengthMean" },
      { Header: "Hardness (Mean)(HRC)", accessor: "hardnessMean" },
      { Header: "Temperature (°C)", accessor: "testTemperature" },
      { Header: "Indv. Values (HRC) ", accessor: "hardnessIndividualValues" },
      { Header: "Location", accessor: "locationOfSample" },
      { Header: "Direction", accessor: "directionOfSample" },


      { Header: "Overcharge Test", accessor: "overchargeTest" },
      { Header: "Overcharge Value", accessor: "overchargeTestValue" },
      { Header: "Overcharge Unit", accessor: "overchargeTestUnit" },

      { Header: "Short Circuit Test", accessor: "shortCircuitTest" },
      { Header: "Short Circuit Value", accessor: "shortCircuitTestValue" },
      { Header: "Short Circuit Unit", accessor: "shortCircuitTestUnit" },

      { Header: "Thermal Test", accessor: "thermalTest" },
      { Header: "Thermal Value", accessor: "thermalTestValue" },
      { Header: "Thermal Unit", accessor: "thermalTestUnit" },

      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;





  // file upload

  const [activeCsvAction, setActiveCsvAction] = useState(null);
  const [showUploadPanel, setShowUploadPanel] = useState(false);

  const handleUploadClick = () => {
    setShowUploadPanel(!showUploadPanel);
    setUploadCsvData(null);
  };

  const handleTemplateClick = () => {
    setActiveCsvAction(activeCsvAction === 'template' ? null : 'template');
  };

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const [uploadCsvData, setUploadCsvData] = useState(null);
  const [selectedCsvTest, setSelectedCsvTest] = useState(null);


  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
    setUploadCsvData(null);
  };



  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "Notch Impact Strength (Mean) (kJ/m²)", key: "notchimpactStrengthMean" },
    { label: "Hardness (Mean) (HRC)", key: "hardnessMean" },
    { label: "Temperature (°C)", key: "testTemperature" },
    { label: "Individual Values (HRC)", key: "hardnessIndividualValues" },
    { label: "Location", key: "locationOfSample" },
    { label: "Direction", key: "directionOfSample" }
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "notchimpactStrengthMean", key: "notchimpactStrengthMean" },
    { label: "hardnessMean", key: "hardnessMean" },
    { label: "testTemperature", key: "testTemperature" },
    { label: "hardnessIndividualValues", key: "hardnessIndividualValues" },
    { label: "locationOfSample", key: "locationOfSample" },
    { label: "directionOfSample", key: "directionOfSample" }
  ];

  const csvLink = {
    filename: "Hardness Test List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Hardness Test Upload Template.csv",
    headers: headersForTemp,
    data: [],
  };



  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadCsvForHardnessTest(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        setActiveCsvAction(null);
        setUploadCsvData(null);

        let filterId = dppIdSelectedForGlobalFilter?.value || null;
        getHardnessTest(filterId, jwtToken);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };


  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  // Map Data to Table Rows
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getHardnessTestReducer?.hardnessTest?.data
      ? getHardnessTestReducer.hardnessTest.data
      : [];

    setLoading(getHardnessTestReducer?.loading || false);

    data.map((item) => {
      const itemObject = {
        hardnessTestId: item.hardnessTestId,
        dppId: item.dppId,
        dppCode: item.dppCode,
        notchimpactStrengthMean: item.notchimpactStrengthMean,
        hardnessMean: item.hardnessMean,
        testTemperature: item.testTemperature,
        hardnessIndividualValues: item.hardnessIndividualValues,
        locationOfSample: item.locationOfSample,
        directionOfSample: item.directionOfSample,
        overchargeTest: item.overchargeTest,
        overchargeTestValue: item.overchargeTestValue,
        overchargeTestUnit: item.overchargeTestUnit,

        shortCircuitTest: item.shortCircuitTest,
        shortCircuitTestValue: item.shortCircuitTestValue,
        shortCircuitTestUnit: item.shortCircuitTestUnit,

        thermalTest: item.thermalTest,
        thermalTestValue: item.thermalTestValue,
        thermalTestUnit: item.thermalTestUnit,

        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateModal(item)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
  }, [getHardnessTestReducer]);

  // ================= CREATE LOGIC =================
  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [allocateButtonName, setAllocateButtonName] = useState("Create");

  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
  };

  const handleCloseAllocateItemModal = () => {
    setAllocateItemModal(false);
    formik.setErrors({});
    formik.resetForm();
    setdppIdSelected("");
  };

  useEffect(() => {
    if (isSuccessAllocateItem)
      setTimeout(() => setIsSuccessAllocateItem(false), 3000);
    if (isErrorAllocateItem)
      setTimeout(() => setIsErrorAllocateItem(false), 3000);
  }, [isSuccessAllocateItem, isErrorAllocateItem]);

  const initialValues = {
    DPPID: "",
    notchimpactStrengthMean: "",
    hardnessMean: "",
    testTemperature: "",
    hardnessIndividualValues: "",
    locationOfSample: "",
    directionOfSample: "",

    overchargeTest: null,
    overchargeTestValue: "",
    overchargeTestUnit: null,
    shortCircuitTest: null,
    shortCircuitTestValue: "",
    shortCircuitTestUnit: "milliohm",
    thermalTest: null,
    thermalTestValue: "",
    thermalTestUnit: "C",
  };

  const validationSchema = Yup.object({
    DPPID: Yup.object().required("Select DPP Code"),
    notchimpactStrengthMean: Yup.number()
      .typeError("Must be a number")
      .required("Required"),
    hardnessMean: Yup.number()
      .typeError("Must be a number")
      .required("Required"),
    testTemperature: Yup.number()
      .typeError("Must be a number")
      .required("Required"),
    hardnessIndividualValues: Yup.number()
      .typeError("Must be a number")
      .required("Required"),
    locationOfSample: Yup.string().required("Required"),
    directionOfSample: Yup.string().required("Required"),


    overchargeTest: Yup.object().nullable().required("Required"),
    overchargeTestValue: Yup.number().typeError("Must be a number").required("Required"),
    overchargeTestUnit: Yup.object().nullable().required("Required"),
    shortCircuitTest: Yup.object().nullable().required("Required"),
    shortCircuitTestValue: Yup.number().typeError("Must be a number").required("Required"),
    shortCircuitTestUnit: Yup.string().required("Required"),
    thermalTest: Yup.object().nullable().required("Required"),
    thermalTestValue: Yup.number().typeError("Must be a number").required("Required"),
    thermalTestUnit: Yup.string().required("Required"),
  });

  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");
    const payload = {
      dppId: values.DPPID?.value,
      notchimpactStrengthMean: String(values.notchimpactStrengthMean),
      hardnessMean: String(values.hardnessMean),
      testTemperature: String(values.testTemperature),
      hardnessIndividualValues: String(values.hardnessIndividualValues),
      locationOfSample: values.locationOfSample,
      directionOfSample: values.directionOfSample,

      overchargeTest: values.overchargeTest?.value,
      overchargeTestValue: String(values.overchargeTestValue),
      overchargeTestUnit: values.overchargeTestUnit?.value,
      shortCircuitTest: values.shortCircuitTest?.value,
      shortCircuitTestValue: String(values.shortCircuitTestValue),
      shortCircuitTestUnit: values.shortCircuitTestUnit,
      thermalTest: values.thermalTest?.value,
      thermalTestValue: String(values.thermalTestValue),
      thermalTestUnit: values.thermalTestUnit,
      cdBy: userId || "system",

    };

    let res = await createHardnessTest(payload, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      getHardnessTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2000);
    } else {
      setErrorMsg(res?.data?.msg || "Something went wrong");
      setIsErrorAllocateItem(true);
      setAllocateButtonName("Create");
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  // ================= EDIT LOGIC =================
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [editButtonName, setEditButtonName] = useState("Update");

  const handleOpenUpdateModal = (data) => {
    setSingleDataForUpdate(data);
    setdppIdForUpdateSelected({ label: data.dppCode, value: data.dppId });
    setOpenUpdateModal(true);
  };

  const handleCloseUpdateModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setOpenUpdateModal(false);
    formikForUpdate.resetForm();
  };

  useEffect(() => {
    if (isSuccessForUpdate)
      setTimeout(() => setIsSuccessForUpdate(false), 3000);
    if (isErrorForUpdate) setTimeout(() => setIsErrorForUpdate(false), 3000);
  }, [isSuccessForUpdate, isErrorForUpdate]);

  const getPassFailOption = (val) => {
    if (val === "Passed" || val === "Pass" || val === 1 || String(val) === "1") {
      return passFailOptions.find(opt => opt.value === 1);
    }
    if (val === "Failed" || val === "Fail" || val === 0 || String(val) === "0") {
      return passFailOptions.find(opt => opt.value === 0);
    }
    return null;
  };


  const validationSchemaForUpdate = Yup.object({
    DPPID: Yup.string().required("Required"),

    notchimpactStrengthMean: Yup.number().typeError("Must be a number").required(" "),
    hardnessMean: Yup.number().typeError("Must be a number").required(" "),
    testTemperature: Yup.number().typeError("Must be a number").required(" "),
    hardnessIndividualValues: Yup.number().typeError("Must be a number").required(" "),
    locationOfSample: Yup.string().required(" "),
    directionOfSample: Yup.string().required(" "),

    overchargeTest: Yup.object().nullable().required(" "),
    overchargeTestValue: Yup.number().typeError("Must be a number").required(" "),
    overchargeTestUnit: Yup.object().nullable().required(" "),
    shortCircuitTest: Yup.object().nullable().required(" "),
    shortCircuitTestValue: Yup.number().typeError("Must be a number").required(" "),
    shortCircuitTestUnit: Yup.string().required(" "),
    thermalTest: Yup.object().nullable().required(" "),
    thermalTestValue: Yup.number().typeError("Must be a number").required(" "),
    thermalTestUnit: Yup.string().required(" "),
  });


  const initialValueForUpdate = {
    hardnessTestId: singleDataForUpdate.hardnessTestId || "",
    DPPID: singleDataForUpdate.dppCode || "",
    notchimpactStrengthMean: singleDataForUpdate.notchimpactStrengthMean || "",
    hardnessMean: singleDataForUpdate.hardnessMean || "",
    testTemperature: singleDataForUpdate.testTemperature || "",
    hardnessIndividualValues: singleDataForUpdate.hardnessIndividualValues || "",
    locationOfSample: singleDataForUpdate.locationOfSample || "",
    directionOfSample: singleDataForUpdate.directionOfSample || "",

    overchargeTest: getPassFailOption(singleDataForUpdate.overchargeTest),
    overchargeTestValue: singleDataForUpdate.overchargeTestValue || "",
    overchargeTestUnit: singleDataForUpdate.overchargeTestUnit
      ? overchargeUnitOptions.find(opt => String(opt.value) === String(singleDataForUpdate.overchargeTestUnit)) || null
      : null,
    shortCircuitTest: getPassFailOption(singleDataForUpdate.shortCircuitTest),
    shortCircuitTestValue: singleDataForUpdate.shortCircuitTestValue || "",
    shortCircuitTestUnit: singleDataForUpdate.shortCircuitTestUnit || "milliohm",

    thermalTest: getPassFailOption(singleDataForUpdate.thermalTest),
    thermalTestValue: singleDataForUpdate.thermalTestValue || "",
    thermalTestUnit: singleDataForUpdate.thermalTestUnit || "C",
  };


  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    const payload = {
      hardnessTestId: values.hardnessTestId,
      dppId: singleDataForUpdate.dppId,
      notchimpactStrengthMean: String(values.notchimpactStrengthMean),
      hardnessMean: String(values.hardnessMean),
      testTemperature: String(values.testTemperature),
      hardnessIndividualValues: String(values.hardnessIndividualValues),
      locationOfSample: values.locationOfSample,
      directionOfSample: values.directionOfSample,

      overchargeTest: values.overchargeTest?.value,
      overchargeTestValue: String(values.overchargeTestValue),
      overchargeTestUnit: values.overchargeTestUnit?.value,
      shortCircuitTest: values.shortCircuitTest?.value,
      shortCircuitTestValue: String(values.shortCircuitTestValue),
      shortCircuitTestUnit: values.shortCircuitTestUnit,
      thermalTest: values.thermalTest?.value,
      thermalTestValue: String(values.thermalTestValue),
      thermalTestUnit: values.thermalTestUnit,


      udBy: userId || "system",
    };

    let res = await editHardnessTest(payload, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getHardnessTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseUpdateModal();
        setEditButtonName("Update");
      }, 2000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.msg || "Failed to update");
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    validationSchema: validationSchemaForUpdate,
    onSubmit: onSubmitForUpdate,
    enableReinitialize: true,
  });

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);
  const [isErrorForDelete, setIsErrorForDelete] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const handleOpenDeleteModal = (data) => {
    setSingleDataForDelete(data);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (isSuccessForDelete)
      setTimeout(() => setIsSuccessForDelete(false), 2000);
    if (isErrorForDelete) setTimeout(() => setIsErrorForDelete(false), 3000);
  }, [isSuccessForDelete, isErrorForDelete]);

  const deleteRecord = async () => {
    setDeleteButtonName("Please wait...");
    let testId = singleDataForDelete.hardnessTestId;
    let udBy = userId || "system";

    let res = await deleteHardnessTest(testId, udBy, jwtToken);

    if (res.status) {
      setIsSuccessForDelete(true);
      getHardnessTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 2000);
    } else {
      setIsErrorForDelete(true);
      setErrorMsgForDelete(res?.data?.msg || "Failed to delete");
      setDeleteButtonName("Delete");
    }
  };

  return (
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4} display="flex" alignItems="center">
                {allocateAccess && (
                  <MDBox display="flex" alignItems="center">

                    {/* 1. Add Record Button */}
                    <Tooltip>
                      <CreateButton tooltip="Add Hardness Test" onClick={() => setOpenCreateModal(true)}>
                        <Icon>add</Icon>
                      </CreateButton>
                    </Tooltip>

                    <CSVLink {...csvLink}>
                      <DownloadDataButton
                        tooltip="Download Hardness Test List"
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadDataButton>
                    </CSVLink>



                    <UploadButton
                      tooltip="Upload CSV"
                      style={{ marginLeft: "1rem", marginTop: "2px" }}
                      type="button"
                      variant={showUploadPanel ? "contained" : "outlined"}
                      color="info"
                      iconOnly
                      onClick={handleUploadClick}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>

                    <CSVLink {...csvLink2}>
                      <DownloadButton
                        tooltip="Download Template"
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>description</Icon>
                      </DownloadButton>
                    </CSVLink>

                    {showUploadPanel && (
                      <MDBox
                        display="flex"
                        alignItems="center"
                        ml={2}
                        p={0.5}
                        px={2}
                      >

                        <input
                          className="choose_file"
                          type="file"
                          accept=".csv"
                          onChange={(e) => setUploadCsvData(e.target.files[0])}
                          style={{ width: "200px" }}
                        />

                        <MDButton
                          disabled={!uploadCsvData?.name || uploadCsvData?.type !== "text/csv"}
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "1rem" }}
                          onClick={uploadCsvHandler}
                        >
                          UPLOAD
                        </MDButton>

                        <IconButton
                          size="small"
                          onClick={() => setShowUploadPanel(false)}
                          style={{ marginLeft: "10px", color: "gray" }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>

                      </MDBox>
                    )}

                  </MDBox>
                )}
              </MDBox>

              <MDBox mb={4} mr={1}>
                {dropdownUI}
              </MDBox>
            </MDBox>

            {/* DataTable */}
            <MDBox pt={0}>
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25],
                }}
                showTotalEntries={true}
                noEndBorder
              />
            </MDBox>

            {/* CREATE MODAL */}
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Hardness Test Record
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginLeft: "-55px",
                      }}
                      onClick={handleCloseAllocateItemModal}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            DPP Code
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="DPPID"
                            value={dppIdSelected}
                            options={dppOptions}
                            onBlur={() =>
                              formik.handleBlur({ target: { name: "DPPID" } })
                            }
                            onChange={(selectedOption) => {
                              setdppIdSelected(selectedOption);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Notch Impact Strength (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchimpactStrengthMean"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.notchimpactStrengthMean}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.notchimpactStrengthMean &&
                              Boolean(formik.errors.notchimpactStrengthMean)
                            }
                          />
                          {formik.touched.notchimpactStrengthMean &&
                            formik.errors.notchimpactStrengthMean && (
                              <TextError
                                msg={formik.errors.notchimpactStrengthMean}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Hardness (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="hardnessMean"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.hardnessMean}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.hardnessMean &&
                              Boolean(formik.errors.hardnessMean)
                            }
                          />
                          {formik.touched.hardnessMean &&
                            formik.errors.hardnessMean && (
                              <TextError msg={formik.errors.hardnessMean} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Test Temperature
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="testTemperature"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.testTemperature}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.testTemperature &&
                              Boolean(formik.errors.testTemperature)
                            }
                          />
                          {formik.touched.testTemperature &&
                            formik.errors.testTemperature && (
                              <TextError msg={formik.errors.testTemperature} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Individual Values
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="hardnessIndividualValues"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.hardnessIndividualValues}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.hardnessIndividualValues &&
                              Boolean(formik.errors.hardnessIndividualValues)
                            }
                          />
                          {formik.touched.hardnessIndividualValues &&
                            formik.errors.hardnessIndividualValues && (
                              <TextError
                                msg={formik.errors.hardnessIndividualValues}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Location of Sample
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="locationOfSample"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter location"
                            value={formik.values.locationOfSample}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.locationOfSample &&
                              Boolean(formik.errors.locationOfSample)
                            }
                          />
                          {formik.touched.locationOfSample &&
                            formik.errors.locationOfSample && (
                              <TextError msg={formik.errors.locationOfSample} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Direction of Sample
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="directionOfSample"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter direction"
                            value={formik.values.directionOfSample}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.directionOfSample &&
                              Boolean(formik.errors.directionOfSample)
                            }
                          />
                          {formik.touched.directionOfSample &&
                            formik.errors.directionOfSample && (
                              <TextError
                                msg={formik.errors.directionOfSample}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsErrorAllocateItem(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsSuccessAllocateItem(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                        <MDBox mt={2}>
                          <MDButton
                            color="info"
                            type="submit"
                            fullWidth
                            disabled={allocateButtonName === "Please wait..."}
                          >
                            {allocateButtonName}
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* UPDATE MODAL */}
            <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update Hardness Test
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginRight: "10px",
                        marginTop: "4px",
                      }}
                      onClick={handleCloseUpdateModal}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">DPP Code</MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="DPPID"
                            fullWidth
                            disabled={true}
                            value={formikForUpdate.values.DPPID}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Notch Impact Strength (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchimpactStrengthMean"
                            fullWidth
                            value={
                              formikForUpdate.values.notchimpactStrengthMean
                            }
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Hardness (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="hardnessMean"
                            fullWidth
                            value={formikForUpdate.values.hardnessMean}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Test Temperature
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="testTemperature"
                            fullWidth
                            value={formikForUpdate.values.testTemperature}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Individual Values
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="hardnessIndividualValues"
                            fullWidth
                            value={
                              formikForUpdate.values.hardnessIndividualValues
                            }
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Location of Sample
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="locationOfSample"
                            fullWidth
                            value={formikForUpdate.values.locationOfSample}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Direction of Sample
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="directionOfSample"
                            fullWidth
                            value={formikForUpdate.values.directionOfSample}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Overcharge Test</MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Pass/Fail..."
                            name="overchargeTest"
                            value={formikForUpdate.values.overchargeTest}
                            options={passFailOptions} // Make sure this array is accessible here
                            onChange={(option) => formikForUpdate.setFieldValue("overchargeTest", option)}
                            onBlur={() => formikForUpdate.setFieldTouched("overchargeTest", true)}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          />
                          {formikForUpdate.touched.overchargeTest && formikForUpdate.errors.overchargeTest && (
                            <TextError msg={formikForUpdate.errors.overchargeTest} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Overcharge Test Value</MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="overchargeTestValue"
                            fullWidth
                            autoComplete="off"
                            value={formikForUpdate.values.overchargeTestValue}
                            onChange={formikForUpdate.handleChange}
                            onBlur={formikForUpdate.handleBlur}
                            error={formikForUpdate.touched.overchargeTestValue && Boolean(formikForUpdate.errors.overchargeTestValue)}
                          />
                          {formikForUpdate.touched.overchargeTestValue && formikForUpdate.errors.overchargeTestValue && (
                            <TextError msg={formikForUpdate.errors.overchargeTestValue} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Overcharge Test Unit</MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Select Unit..."
                            name="overchargeTestUnit"
                            value={formikForUpdate.values.overchargeTestUnit}
                            options={overchargeUnitOptions}
                            onChange={(option) => formikForUpdate.setFieldValue("overchargeTestUnit", option)}
                            onBlur={() => formikForUpdate.setFieldTouched("overchargeTestUnit", true)}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          />
                          {formikForUpdate.touched.overchargeTestUnit && formikForUpdate.errors.overchargeTestUnit && (
                            <TextError msg={formikForUpdate.errors.overchargeTestUnit} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Short Circuit Test</MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Pass/Fail..."
                            name="shortCircuitTest"
                            value={formikForUpdate.values.shortCircuitTest}
                            options={passFailOptions}
                            onChange={(option) => formikForUpdate.setFieldValue("shortCircuitTest", option)}
                            onBlur={() => formikForUpdate.setFieldTouched("shortCircuitTest", true)}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          />
                          {formikForUpdate.touched.shortCircuitTest && formikForUpdate.errors.shortCircuitTest && (
                            <TextError msg={formikForUpdate.errors.shortCircuitTest} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Short Circuit Test Value</MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="shortCircuitTestValue"
                            fullWidth
                            autoComplete="off"
                            value={formikForUpdate.values.shortCircuitTestValue}
                            onChange={formikForUpdate.handleChange}
                            onBlur={formikForUpdate.handleBlur}
                            error={formikForUpdate.touched.shortCircuitTestValue && Boolean(formikForUpdate.errors.shortCircuitTestValue)}
                          />
                          {formikForUpdate.touched.shortCircuitTestValue && formikForUpdate.errors.shortCircuitTestValue && (
                            <TextError msg={formikForUpdate.errors.shortCircuitTestValue} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Short Circuit Test Unit</MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="shortCircuitTestUnit"
                            fullWidth
                            value={formikForUpdate.values.shortCircuitTestUnit}
                            onChange={formikForUpdate.handleChange}
                            disabled={true}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Thermal Test</MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Pass/Fail..."
                            name="thermalTest"
                            value={formikForUpdate.values.thermalTest}
                            options={passFailOptions}
                            onChange={(option) => formikForUpdate.setFieldValue("thermalTest", option)}
                            onBlur={() => formikForUpdate.setFieldTouched("thermalTest", true)}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          />
                          {formikForUpdate.touched.thermalTest && formikForUpdate.errors.thermalTest && (
                            <TextError msg={formikForUpdate.errors.thermalTest} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Thermal Test Value</MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="thermalTestValue"
                            fullWidth
                            autoComplete="off"
                            value={formikForUpdate.values.thermalTestValue}
                            onChange={formikForUpdate.handleChange}
                            onBlur={formikForUpdate.handleBlur}
                            error={formikForUpdate.touched.thermalTestValue && Boolean(formikForUpdate.errors.thermalTestValue)}
                          />
                          {formikForUpdate.touched.thermalTestValue && formikForUpdate.errors.thermalTestValue && (
                            <TextError msg={formikForUpdate.errors.thermalTestValue} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Thermal Test Unit</MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="thermalTestUnit"
                            fullWidth
                            value={formikForUpdate.values.thermalTestUnit}
                            onChange={formikForUpdate.handleChange}
                            disabled={true}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12}>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsErrorForUpdate(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsgForUpdate}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsSuccessForUpdate(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Updated successfully
                          </Alert>
                        </Collapse>
                        <MDBox mt={2}>
                          <MDButton
                            color="info"
                            type="submit"
                            fullWidth
                            disabled={editButtonName === "Please wait..."}
                          >
                            {editButtonName}
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* DELETE MODAL */}
            <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2} display="flex" justifyContent="space-between">
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    color="error"
                    onClick={deleteRecord}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isErrorForDelete}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          size="small"
                          onClick={() => setIsErrorForDelete(false)}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMsgForDelete}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccessForDelete}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          size="small"
                          onClick={() => setIsSuccessForDelete(false)}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Deleted Successfully
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
            <CreateTestRecordModal
              open={openCreateModal}
              handleClose={() => setOpenCreateModal(false)}
              jwtToken={jwtToken}
              userId={userId}
              dppOptions={dppOptions}
              onSuccessRefresh={(testTypeCreated) => { }}
            />
          </Grid>
        </Grid>
      </MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  getHardnessTestReducer: state.getHardnessTestReducer,
  getProductsListForDppReducer: state.getProductsListForDppReducer,
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getHardnessTest: (dppId, jwtToken) =>
    dispatch(getHardnessTest(dppId, jwtToken)),
  createHardnessTest: (payload, jwtToken) =>
    dispatch(createHardnessTest(payload, jwtToken)),
  editHardnessTest: (payload, jwtToken) =>
    dispatch(editHardnessTest(payload, jwtToken)),
  deleteHardnessTest: (testId, udBy, jwtToken) =>
    dispatch(deleteHardnessTest(testId, udBy, jwtToken)),
  getProductsListForDpp: (jwtToken) =>
    dispatch(getProductsListForDpp(jwtToken)),

  uploadCsvForHardnessTest: (data, jwtToken) =>
    dispatch(uploadCsvForHardnessTest(data, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HardnessTest);
